import React, { useCallback, useEffect, useState } from 'react';
import {Helmet} from "react-helmet";
import { useDispatch } from 'react-redux';
import { Box, Container, Grid, Typography } from '@mui/material';
// import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
// import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
// import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import Search from '../components/widgets/search.widget';
// import StatWidget from '../components/widgets/stat.widget';
import {
  APIResponse,
  Item,
  ListingResponse,
  TypeSnackbarPayload,
} from '../utilities/types';
import { showSnackbar } from '../store/slices/common.slice';
import ItemWidget from '../components/widgets/item.widget';
import { getItemList } from '../apis';

const ItemsPage: React.FC = () => {
  const dispatch = useDispatch();

  const [items, setItems] = useState<Item[]>([]);

  const loadItems = useCallback(
    async (searchTerm: string) => {
      try {
        const payload = { filters: { search: '', active: 1 } };
        if (searchTerm !== '') {
          payload.filters.search = searchTerm;
        }
        const response = (await getItemList(payload)) as APIResponse<ListingResponse>;
        if (response.status) {
          setItems(Array.isArray(response.data?.items) ? response.data.items : []);
        }
      } catch (err: any) {
        const snakbarpayload: TypeSnackbarPayload = { severity: 'error', message: err.message };
        if (err?.data?.message) {
          snakbarpayload.message = err?.data?.message;
        } else if (err?.statusText) {
          snakbarpayload.message = err?.statusText;
        }
        dispatch(showSnackbar(snakbarpayload));
      }
    },
    [dispatch]
  );

  // const renderStats = () => (
  //   <Grid container spacing={4} justifyContent="center">
  //     <Grid size={{ xs: 12, sm: 4 }}>
  //       <StatWidget
  //         icon={<TrendingUpOutlinedIcon sx={{ fontSize: 18, color: 'green' }} />}
  //         label="Avg. Price"
  //         value="₹35,000/ton"
  //         size="small"
  //       />
  //     </Grid>

  //     <Grid size={{ xs: 12, sm: 4 }}>
  //       <StatWidget
  //         icon={<PeopleOutlinedIcon sx={{ fontSize: 18, color: '#155dfc' }} />}
  //         label="Participants"
  //         value="156"
  //         size="small"
  //       />
  //     </Grid>

  //     <Grid size={{ xs: 12, sm: 4 }}>
  //       <StatWidget
  //         icon={<AccessTimeOutlinedIcon sx={{ fontSize: 18, color: '#f54a00' }} />}
  //         label="Price Trend"
  //         value="+12%"
  //         size="small"
  //       />
  //     </Grid>
  //   </Grid>
  // );

  useEffect(() => {
    loadItems('');
  }, [loadItems]);

  return (
    <>
      <Helmet>
        <title>Scrap Categories and Products - Scrap E-Auction Online Scrap Metal Auction Platform</title>
        <meta name="description" content="Categories of scrap materials and products we offer" />
      </Helmet>
      <Container sx={{ py: 4, bgcolor: '#fbf9fa' }}>
        <Box
          sx={{
            pt: 3,
            pb: 8,
            px: 2,
          }}
        >
          <Box sx={{ mb: 4 }}>
            <Typography variant="h1" gutterBottom sx={{ fontWeight: '600' }}>
              Scrap Categories
            </Typography>
            <Typography variant="body1" gutterBottom color="textSecondary">
              Browse through our comprehensive range of scrap categories. Each category features
              active auctions from verified buyers and sellers across India.
            </Typography>
          </Box>
          <Box
            sx={{
              mb: 3,
              width: '100%',
            }}
          >
            <Search
              placeholder="Search items..."
              onFilter={(term) => {
                console.log('Filter items with term:', term);
                loadItems(term);
              }}
            />
          </Box>
          {items.length > 0 ? (
            <Grid container spacing={3}>
              {items.map((cat: Item, catIndex) => (
                <Grid key={`item-category-index-${catIndex}`} size={{ xs: 12, sm: 2, md: 4 }}>
                  <ItemWidget item={cat} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                height: 300,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography variant="body2" color="text.error">
                No Item Found
              </Typography>
            </Box>
          )}
        </Box>
      </Container>
    </>
  );
};

export default ItemsPage;
